import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@services/translate/translate.service';

import moment from 'moment';

export const APP_DATE_FORMATS = {
  parse: { dateInput: 'DD.MM.', },
  display: { dateInput: 'DD.MM.', monthYearLabel: 'MMMM', dateA11yLabel: 'LL', monthYearA11yLabel: 'MMMM', },
};

@Component({
    selector: 'day-month-input',
    templateUrl: './day-month-input.component.html',
    styleUrls: ['./day-month-input.component.scss'],
    providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }, { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }],
    standalone: false
})

export class DayMonthInputComponent implements OnInit {

  @Output() onChange = new EventEmitter<any>();
  @Input() key: string;
  @Input() value: string;
  @Input() translationPrefix: string;
  date = new UntypedFormControl(moment());
  placeholder = '';

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    this.placeholder = this.translate.get(this.translationPrefix ? this.translationPrefix + '.' + this.key : this.key);
  }

  change(event) {
    this.onChange.emit(event);
  }

  getFieldTitle() {
    const translations = this.translate.get(this.translationPrefix?.length ? this.translationPrefix : null);
    return translations?.[this.key] || this.key;
  }
}
